// extracted by mini-css-extract-plugin
export default {"item":"WSMenu-module_item-mayLd","icon":"WSMenu-module_icon-pOae3","destructive":"WSMenu-module_destructive-rIIL9","sidebar":"WSMenu-module_sidebar-a0lQb"};